import React from 'react';
import {
  Container,
  Paper,
  Box,
  Alert,
} from '@mui/material';
import { useConversation } from '../contexts/ConversationContext';
import MessageList from './MessageList';
import AudioControls from './AudioControls';
import ConnectionStatus from './ConnectionStatus';

const ConversationInterface: React.FC = () => {
  const { error } = useConversation();

  return (
    <Container maxWidth={false} 
          disableGutters // This removes all default Container padding 
          sx={{ 
            height: '100vh', 
            p: 0, 
            m: 0,
            // Enhanced mobile-specific styles
            '@media (max-width: 768px)': {
              p: 0,
              m: 0,
            }
          }}
    >
      <Box className="conversation-container">
        {/* Main conversation area */}
        <Paper 
          className="conversation-content"
          elevation={8}
          sx={{ 
            borderRadius: 0,
            overflow: 'hidden',
            // Mobile-optimized elevation
            '@media (max-width: 768px)': {
              elevation: 4,
            },
            '@media (max-width: 480px)': {
              elevation: 2,
            }
          }}
        >
          {/* Connection Status - Always visible (contains New Conversation button) */}
          <ConnectionStatus />
          
          {/* Error Display */}
          {error && (
            <Box sx={{ p: 2 }}>
              <Alert severity="error" onClose={() => {}}>
                {error}
              </Alert>
            </Box>
          )}          {/* Messages */}
          <Box className="messages-container" sx={{ mt: 0, pt: 0 }}>
            <MessageList />
          </Box>

          {/* Controls */}          <Box className="controls-container">
            <AudioControls />
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ConversationInterface;
